export const UPDATE_USER = 'userReducer/UPDATE_USER';
export type UPDATE_USER = typeof UPDATE_USER;

export const CLEAR_USER = 'userReducer/CLEAR_USER';
export type CLEAR_USER = typeof CLEAR_USER;



// WEBPACK FOOTER //
// ./src/modules/user/constants.ts